import React from "react";
import {Box, Button, Icon, Modal, Text} from "@nike/eds";

interface ManualClearingNoInventoryModalProps {
    isOpen: boolean;
    onDismiss: () => void;
    documentIds: string[];
}

function ManualClearingNoInventoryModal({
                                            isOpen,
                                            onDismiss,
                                        }: ManualClearingNoInventoryModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            onDismiss={onDismiss}
            headerSlot= {<span> <Icon name="AlertCircle" size="l" color={"red"} style={{verticalAlign: "middle"}}/> No remaining inventory </span>}
            footerSlot={
                        <Button variant="primary" onClick={onDismiss}>Close</Button>
                }
        >
            <Box><Text>There is no inventory left that can be cleared</Text></Box>
        </Modal>
    );
}

export default ManualClearingNoInventoryModal;
